var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0.75 0.75 22.5 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,15.75A1.252,1.252,0,0,0,20.75,17v3a.752.752,0,0,1-.75.75H4A.752.752,0,0,1,3.25,20V17a1.25,1.25,0,0,0-2.5,0v3A3.254,3.254,0,0,0,4,23.25H20A3.254,3.254,0,0,0,23.25,20V17A1.252,1.252,0,0,0,22,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,.75A1.252,1.252,0,0,0,10.75,2V13.331L6.8,10.04A1.251,1.251,0,0,0,5.04,10.2,1.251,1.251,0,0,0,5.2,11.96l6,5a1.269,1.269,0,0,0,.2.116,1.179,1.179,0,0,0,.143.082,1.174,1.174,0,0,0,.911,0,1.3,1.3,0,0,0,.14-.081,1.279,1.279,0,0,0,.2-.116l6-5A1.25,1.25,0,0,0,18,9.75a1.255,1.255,0,0,0-.8.29L13.25,13.331V2A1.252,1.252,0,0,0,12,.75Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.a43b49138b374b74e157542836a68098.svg";
export { ForwardRef as ReactComponent };